<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="La Petite Voie de Sainte Thérèse de l'Enfant Jésus" />
            <PetiteVoie />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import PetiteVoie from './PetiteVoie.vue';


export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        PetiteVoie,
        FooterComp,
    }
}
</script>